import * as React from 'react'

import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useRaportForm } from '../context/RaportFormContext'
import { supportsSignatures } from '../utils/reportDefaultParams'

/** Podpisy w kolumnie opcji raportu - tylko w panelu pod wierszem listy. */
const SignatureFields = () => {
  const { t } = useLocalize()
  const { data, setData, signaturesFor } = useRaportForm()

  if (signaturesFor == null || !supportsSignatures(signaturesFor)) return null

  return (
    <>
      <CheckboxWithLabelField
        field="issuerSignature"
        data={data}
        setData={setData}
        label={t('printout.issuer-signature')}
      />
      <CheckboxWithLabelField
        field="driverSignature"
        data={data}
        setData={setData}
        label={t('printout.driver-signature')}
      />
    </>
  )
}

export default SignatureFields
